import React from "react";

import { deleteEmpty } from "utils/helpers";
import { formValid } from "utils/validate";


export default (FilltersForm, model, timeout = 500, isDeleteEmpty = true) => {
    class FilltersFormHOC extends React.PureComponent {

        ref = React.createRef();

        formValue = null;
        timer = null;

        componentWillUnmount() {
            clearTimeout(this.timer);
        }

        getValues = () => {
            // console.log("this.props.proxy", this.props.proxy, this.ref.current);
            if (this.props.proxy)
                return this.props.proxy(this.ref.current.getFormValue());
            return this.ref.current.getFormValue();
        };

        onChange = (formValue) => {
            clearTimeout(this.timer);

            this.timer = setTimeout(() => {
                if (!model || formValid(model.check(formValue))) {
                    let _formValue = isDeleteEmpty ? deleteEmpty({ ...formValue }) : formValue;

                    if (JSON.stringify(_formValue) !== JSON.stringify(this.formValue)) {
                        this.formValue = _formValue;
                        this.props.onChange(
                            this.props.proxy ? this.props.proxy(_formValue) : _formValue
                        );
                    }
                }
            }, typeof timeout === "function" ? timeout(this.props) : timeout);
        };

        render() {
            return (<FilltersForm {...this.props} onChange={this.onChange} ref={this.ref} />);
        };
    };

    return FilltersFormHOC;
};
